import categoryService from "app/common/services/categoryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import { BasicDurations } from "app/services/DurationService";

const { LAST_TWENTY_EIGHT_DAYS, LAST_MONTH, LAST_THREE_MONTHS, LAST_SIX_MONTHS, LAST_TWELVE_MONTHS } = BasicDurations;

const OVERRIDE_DATE_PICKER_PRESET = [
    LAST_TWENTY_EIGHT_DAYS,
    LAST_MONTH,
    LAST_THREE_MONTHS,
    LAST_SIX_MONTHS,
    LAST_TWELVE_MONTHS,
];

export const resolveOverrideDatePickerPreset = () => {
    const category = proNavigator.getParams().category;
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);
    return CategoryServiceUtils.hasSegments(categoryObject) ? OVERRIDE_DATE_PICKER_PRESET : null;
};

export const resolveOverrideDatePickerPreset_v2 = () => {
    const params = proNavigator.getParams();
    const { category, country } = params;
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);
    const isLimitedDuration =
        categoryObject?.segments?.length > 1 && country && country === String(WORLDWIDE_COUNTRY_ID);

    return isLimitedDuration ? OVERRIDE_DATE_PICKER_PRESET : null;
};
